import scaffoldBlobValidator from '@/scaffold/form/scaffold-blob-validator';
import blobFileItemReader from '@/file/blob-file-item-reader';
import jsyaml from 'js-yaml';

export default {
  extract(file) {
    const readableFile = {
      blob: file,
    };

    return Promise.resolve()
      .then(() => {
        return scaffoldBlobValidator.validateBlobFiles(
          readableFile,
          null,
        );
      })
      .then(() => {
        return blobFileItemReader.read(readableFile);
      })
      .then(() => {
        return jsyaml.safeLoad(readableFile.content);
      });
  },
};
